const styles = (theme) => ({
  button: {
    width: '270px',
    height: '50px',
  },
  paper: {
    borderRadius: '6px',
    [theme.breakpoints.up('md')]: {
      width: '100%',
      textAlign: 'center',
    },
    [theme.breakpoints.down('md')]: {
      width: '95%',
      textAlign: 'center',
      margin: 'auto',
    },
  },
});

export default styles;
